import MuiTableHead from "@mui/material/TableHead";
import React, { useState } from "react";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Checkbox from "@mui/material/Checkbox";
import TableSortLabel from "@mui/material/TableSortLabel";
import styled from "styled-components";
import { svgFilter } from "./images";

const HiddenSpanOrder = styled.span`
  border: 0px solid;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -8px;
  overflow: hidden;
  padding: 0px;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

const IconButton = styled.div`
  width: 18px;
  height: 18px;

  svg {
    width: 90%;
    height: 90%;
    path {
      stroke: var(--Text-Primary);
      fill: var(--Text-Primary);
    }
  }
`;

function TableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
    columns,
    isSelectable,
    sort,
    openFilter,
    setOpenFilter,
    filters,
  } = props;
  const createSortHandler = (property, orderType, parse) => (event) => {
    onRequestSort(event, property, orderType, parse);
  };

  return (
    <MuiTableHead>
      <TableRow>
        {isSelectable ? (
          <TableCell padding="checkbox">
            <Checkbox
              color="primary"
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={rowCount > 0 && numSelected === rowCount}
              inputProps={{
                "aria-label": "select all rows",
              }}
              onClick={onSelectAllClick}
            />
          </TableCell>
        ) : null}
        {columns.map((headCell) => {
          const {
            label,
            numeric,
            id,
            title,
            cellClassName,
            hidden,
            parse,
            width,
            sort: columnSort = true,
            expandable = false,
            expandColumn,
            actions,
          } = headCell;
          const orderType = numeric ? "numeric" : "alphabetical";
          const className = `${orderBy === id ? "active" : ""}${
            sort && columnSort ? " sorting" : ""
          }${cellClassName ? cellClassName : ""}`;
          if (hidden) {
            return null;
          }
          const hasFilter = filters.some(
            (filter) => filter?.column === id && filter.value?.length > 0
          );

          return (
            <TableCell
              key={id}
              align={actions ? "center" : numeric ? "right" : "left"}
              sortDirection={orderBy === id ? order : false}
              className={className}
              title={title}
              width={width}
            >
              {sort &&
              columnSort &&
              !expandable &&
              !expandColumn &&
              !actions ? (
                <TableSortLabel
                  active={orderBy === id}
                  direction={orderBy === id ? order : "desc"}
                  onClick={createSortHandler(id, orderType, parse)}
                  hideSortIcon={!sort}
                >
                  {label}
                  {hasFilter ? (
                    <IconButton
                      onClick={(e) => {
                        e.stopPropagation();
                        setOpenFilter(true);
                      }}
                    >
                      {svgFilter}
                    </IconButton>
                  ) : null}
                  {orderBy === id ? (
                    <HiddenSpanOrder>
                      {order === "desc"
                        ? "sorted descending"
                        : "sorted ascending"}
                    </HiddenSpanOrder>
                  ) : null}
                </TableSortLabel>
              ) : (
                label
              )}
            </TableCell>
          );
        })}
      </TableRow>
    </MuiTableHead>
  );
}

export default TableHead;
